export default __webpack_public_path__ + "static/ft2018-cec38cdd8f8255818e559020eb835b39.png";